import { ChevronRightIcon } from '@heroicons/react/24/outline';
import type { DmNotificationPatientRow } from '../../../services/dmNotifications';
import { MonitoringPatientIdentity } from '../shared/MonitoringPatientIdentity';

interface NotificationPatientCellProps {
    row: DmNotificationPatientRow;
    expanded: boolean;
    onToggle: (patientId: string) => void;
}

export function NotificationPatientCell({ row, expanded, onToggle }: NotificationPatientCellProps) {
    return (
        <div className="flex items-center gap-2.5 min-w-0">
            <button
                type="button"
                aria-expanded={expanded}
                aria-label={`${expanded ? 'Hide' : 'Show'} notifications for ${row.patientName}`}
                onClick={(event) => {
                    // The row's own click handler toggles too; this button is its keyboard path.
                    event.stopPropagation();
                    onToggle(row.patientId);
                }}
                className="-ml-1 grid h-6 w-6 shrink-0 place-items-center rounded text-gray-400 hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400"
            >
                <ChevronRightIcon
                    className={`h-4 w-4 transition-transform ${expanded ? 'rotate-90' : ''}`}
                />
            </button>
            <MonitoringPatientIdentity patient={row} />
        </div>
    );
}
